<template>
    <div class="edit">
        <div class="row" v-if="enquiry">
            <div class="col-12">
                <div
                    class="enquiry-nav d-flex flex-column flex-md-row justify-content-between align-items-center py-4 border-bottom"
                >
                    <div class="nav-item mb-3 mb-md-0" :class="{ active: !hasStatus(['rejected_by_client']) }">
                        <div class="number">1</div>
                        <div class="text-muted">Enquiry created</div>
                    </div>

                    <div
                        class="nav-item mb-3 mb-md-0"
                        :class="{ active: !hasStatus(['rejected_by_client', 'pending', 'assigned_to_therapist']) }"
                    >
                        <div class="number">2</div>
                        <div class="text-muted">Enquiry accepted</div>
                    </div>

                    <div
                        class="nav-item mb-3 mb-md-0"
                        :class="{
                            active: !hasStatus(['rejected_by_client', 'pending', 'assigned_to_therapist', 'accepted'])
                        }"
                    >
                        <div class="number">3</div>
                        <div class="text-muted">Request booking</div>
                    </div>

                    <div
                        class="nav-item mb-3 mb-md-0"
                        :class="{
                            active: !hasStatus([
                                'rejected_by_client',
                                'pending',
                                'assigned_to_therapist',
                                'accepted',
                                'request_booking'
                            ])
                        }"
                    >
                        <div class="number">4</div>
                        <div class="text-muted">Booking accepted</div>
                    </div>
                </div>

                <div :class="`${statusColor()} p-5 text-white text-center`">
                    <h3 class="text-center">Status: {{ statusText() }}</h3>
                    <div class="text-center">
                        <h6 class="mx-auto" style="max-width: 650px">{{ statusDescription() }}</h6>
                    </div>
                    <a
                        class="font-weight-bold text-white"
                        :href="`${frontendUrl}/services/show/${enquiry.discipline.id}`"
                    >
                        {{ enquiry.discipline.name }}
                    </a>
                </div>

                <div class="card mt-5 mt-md-10 w-100" v-if="hasStatus(['accepted', 'request_booking', 'booking_accepted'])">
                    <div class="body p-4 row">
                        <div class="col-12 col-md-3 text-center text-md-left mb-3 mb-md-0">
                            <img
                                style="width: 12rem; height: 12rem; border-radius: 9999px"
                                :src="
                                    `${frontendUrl}/img/${enquiry.therapist.profile_picture ||
                                        'missing.png'}?w=720&h=720&fit=crop`
                                "
                                alt=""
                            />
                        </div>
                        <div class="col-12 col-md-9 py-2 text-center text-md-left">
                            <a class="h5" :href="`${frontendUrl}/therapists/profile/${enquiry.therapist.id}`">
                                {{ enquiry.therapist.first_name }} {{ enquiry.therapist.last_name }}
                            </a>

                            <ul class="border rounded mt-2 mb-4 pl-0">
                                <li
                                    class="d-flex justify-content-between p-4"
                                    :class="{ 'border-bottom': key < enquiry.therapist.disciplines.length - 1 }"
                                    v-for="(discipline, key) in enquiry.therapist.disciplines"
                                    :key="`discipline-${discipline.id}`"
                                >
                                    <span class="text-truncate">
                                        {{ discipline.name }}
                                    </span>

                                    <a
                                        :href="`${frontendUrl}/services/show/${discipline.id}`"
                                        class="link-primary ml-3 ml-md-0 text-nowrap"
                                    >
                                        Find out more
                                    </a>
                                </li>
                            </ul>

                            <div class="text-muted font-italic text-left">
                                {{ therapistSkills }}
                            </div>

                            <hr class="my-3" />

                            <a
                                :href="`${frontendUrl}/contact/therapist/${enquiry.therapist.id}`"
                                class="btn btn-primary btn-sm float-right"
                            >
                                Contact therapist
                            </a>
                        </div>
                    </div>
                </div>

                <div
                    class="card mt-5 mt-md-10 w-100"
                    v-if="hasStatus(['accepted', 'request_booking', 'booking_accepted'])"
                    id="session-dates"
                >
                    <div class="h6 p-4 border-bottom">Session details</div>
                    <div class="body p-4">
                        <div
                            class="card"
                            :class="{ 'mt-5': index != 0 }"
                            v-for="(patient, index) in enquiry.patients"
                            :key="`patient-card-${patient.id}`"
                        >
                            <div class="h6 p-4 border-bottom bg-light">
                                {{ patient.first_name }} {{ patient.last_name }}
                            </div>
                            <div class="body">
                                <div class="p-4 border-bottom row">
                                    <div class="col-12 col-md-4 text-muted">
                                        Date
                                    </div>

                                    <div class="col-12 col-md-8 mt-3 mt-md-0">
                                        <small class="text-danger ml-2" v-if="warnings.selectSession">
                                            <i class="fa fa-exclamation-triangle" />
                                            Please select a date in order to proceed with a booking
                                        </small>

                                        <ul
                                            class="border rounded mb-4 pl-0"
                                            :class="{ 'mt-3': warnings.selectSession }"
                                        >
                                            <li
                                                class="d-flex flex-column flex-md-row justify-content-between align-items-center p-4"
                                                :class="{
                                                    'border-bottom': key < patient.suggested_sessions.length - 1
                                                }"
                                                v-for="(session, key) in patient.suggested_sessions"
                                                :key="`date-suggestion-${key}`"
                                            >
                                                <span class="text-truncate">
                                                    {{ session.session_start | date }}
                                                </span>

                                                <button
                                                    class="btn btn-sm mt-3 mt-md-0"
                                                    :class="{
                                                        'btn-primary': session.accepted,
                                                        'btn-outline-primary': !session.accepted
                                                    }"
                                                    :disabled="enquiry.status != 'accepted'"
                                                    style="width: 150px"
                                                    v-on:click="
                                                        if (enquiry.status == 'accepted') {
                                                            warnings.selectSession = false;
                                                            session.accepted = true;
                                                            patient.suggested_sessions
                                                                .filter((s) => s.id != session.id)
                                                                .forEach((s) => (s.accepted = false));
                                                        }
                                                    "
                                                >
                                                    {{ session.accepted ? 'Selected' : 'Select' }}
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="p-4 row">
                                    <div class="col-12 col-md-4 text-muted">
                                        Estimated price (<small class="text-danger">Excluding any travel fees</small>)
                                    </div>

                                    <div class="col-12 col-md-8 mt-3 mt-md-0">
                                        {{
                                            patient.suggested_sessions[0].estimated_cost == 0
                                                ? 'not available'
                                                : `&pound;${patient.suggested_sessions[0].estimated_cost}`
                                        }}
                                    </div>
                                </div>
                                <div class="p-4 row">
                                    <div class="col-12 col-md-4 text-muted">
                                        Appointment place
                                    </div>

                                    <div class="col-12 col-md-8 mt-3 mt-md-0">
                                        {{
                                            enquiry.session_location == 'online'
                                                ? 'Online'
                                                : enquiry.complete_address || "Couldn't be retrieved"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mt-5 mt-md-10 w-100" v-if="hasStatus(['accepted'])">
                    <div class="body p-4 d-flex align-items-center">
                        <i class="fa fa-exclamation-triangle fa-3x text-danger" />
                        <h5 class="ml-3">
                            Please note: you have
                            <span class="text-danger font-weight-bold">{{ enquiry.client_minutes_left }}</span>
                            left to decide if you want to make a booking.
                        </h5>
                    </div>
                </div>

                <div class="card mt-5 mt-md-10 w-100" v-if="hasStatus(['booking_accepted'])">
                    <div class="body p-4 justify-content-between d-flex align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fa fa-exclamation-triangle fa-3x text-danger" />
                            <h5 class="ml-3">
                                Please read our payment and cancellation policy
                            </h5>
                        </div>
                        <a
                            :href="`${frontend_url}/session-payment-and-cancellation-policy`"
                            class="btn btn-primary float-right"
                        >
                            Read Policy
                        </a>
                    </div>
                </div>

                <div class="booking mt-5 text-center" v-if="hasStatus(['accepted'])">
                    <div>
                        <vue-check-input
                            :check-value="true"
                            v-model="agrees"
                            label-class="form-check-label small text-muted"
                        >
                            <template v-slot:label>
                                I agree with
                                <a :href="`${frontendUrl}/privacy-policy`">Privacy Policy</a>
                                and
                                <a :href="`${frontendUrl}/terms-and-conditions`">Terms & Conditions</a>
                            </template>
                        </vue-check-input>
                    </div>

                    <button class="btn btn-primary btn-lg rounded mt-3" v-on:click="createBooking">
                        Create booking
                    </button>
                </div>

                <div class="card mt-5 mt-md-10 w-100">
                    <div class="h6 p-4 border-bottom">Enquiry Details</div>
                    <div class="body p-4">
                        <div class="pb-4 border-bottom row">
                            <div class="col-12 col-md-3 text-muted mb-3 mb-md-0">
                                Patient{{ enquiry.patients.length > 1 ? 's' : '' }}
                            </div>
                            <div class="col-12 col-md-8 offset-0 offset-md-1">
                                <div
                                    class="card"
                                    :class="{ 'mt-5': index != 0 }"
                                    v-for="(patient, index) in enquiry.patients"
                                    :key="`patient-card-${patient.id}`"
                                >
                                    <div class="h6 p-4 border-bottom bg-light">
                                        {{ patient.first_name }} {{ patient.last_name }}
                                    </div>
                                    <div class="body">
                                        <div class="p-4 border-bottom row">
                                            <div class="col-12 col-md-3 text-muted">
                                                Date of birth
                                            </div>

                                            <div class="offset-0 offset-md-2 col-12 col-md-7">
                                                {{ patient.date_of_birth | date }}
                                            </div>
                                        </div>
                                        <div class="p-4 row">
                                            <div class="col-12 col-md-3 text-muted">
                                                Additional Info
                                            </div>

                                            <div class="offset-0 offset-md-2 col-12 col-md-7">
                                                {{ patient.additional_info }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="py-4 border-bottom row">
                            <div class="col-12 col-md-3 text-muted mb-3 mb-md-0">Therapy</div>
                            <div class="col-12 col-md-8 offset-0 offset-md-1">
                                {{ enquiry.discipline.name }} / {{ enquiry.session_type.name }}
                            </div>
                        </div>

                        <div class="py-4 border-bottom row">
                            <div class="col-12 col-md-3 text-muted mb-3 mb-md-0">Preferred place for appointment</div>
                            <div class="col-12 col-md-8 offset-0 offset-md-1">
                                <div v-if="enquiry.preferred_address == 'none'">Not specified</div>
                                <div v-else-if="enquiry.preferred_address == 'same'">
                                    Same as the one I provided for my address
                                </div>
                                <div v-else-if="enquiry.preferred_address == 'venue'">Owl Centre venue</div>
                                <div v-else-if="enquiry.preferred_address == 'online'">Online</div>
                                <div v-else>{{ enquiry.preferred_session_address.complete }}</div>
                            </div>
                        </div>

                        <div class="pt-4 row">
                            <div class="col-12 col-md-3 text-muted mb-3 mb-md-0">Additional information</div>
                            <div class="col-12 col-md-8 offset-0 offset-md-1">
                                {{ enquiry.client_notes }}
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="d-flex mt-5 mb-15 flex-column flex-md-row"
                    :class="{
                        'justify-content-between': !hasStatus(['rejected_by_client']),
                        'justify-content-center': hasStatus(['rejected_by_client'])
                    }"
                >
                    <button
                        v-on:click="modals.cancel = true"
                        v-if="hasStatus(['pending', 'assigned_to_therapist', 'accepted', 'request_booking'])"
                        class="btn btn-danger btn-lg rounded px-6 py-2 mb-3 mb-md-0"
                    >
                        Cancel enquiry
                    </button>
                    <router-link
                        :to="`/enquiries/${enquiry.id}/edit`"
                        v-if="hasStatus(['pending', 'assigned_to_therapist', 'accepted', 'request_booking'])"
                        class="btn btn-primary btn-lg rounded px-6 py-2"
                    >
                        Update enquiry
                    </router-link>
                    <router-link
                        to="/enquiries/create"
                        v-if="hasStatus(['rejected_by_client'])"
                        class="btn btn-primary btn-lg rounded px-6 py-2"
                    >
                        Submit again
                    </router-link>
                </div>
            </div>

            <vue-modal v-model="modals.cancel">
                <template slot="body">
                    <div class="d-flex justify-content-center my-3">
                        <div class="header text-center">
                            <i class="fa fa-exclamation-triangle fa-3x text-danger" />
                            <h4 class="my-3">Please confirm</h4>
                            <div class="text-muted">
                                Do you really want to cancel this enquiry? This process cannot be undone.
                            </div>

                            <div class="border-top w-100 mt-4 pt-4">
                                <button v-on:click="modals.cancel = false" class="btn btn-secondary btn-sm px-4 mr-3">
                                    No
                                </button>

                                <button v-on:click="cancelEnquiry" class="btn btn-danger btn-sm px-4">
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </template>
            </vue-modal>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';

    import VueModal from 'simple-modal-vue';
    import VueCheckInput from '@components/checkInput';

    import enquiriesService from '@api/enquiries';

    export default Vue.extend({
        components: {
            VueModal,
            VueCheckInput
        },
        data() {
            return {
                agrees: false,
                enquiry: null,
                frontendUrl: window.app.frontendUrl,
                modals: {
                    cancel: false
                },
                warnings: {
                    selectSession: false
                }
            };
        },
        filters: {
            date(value) {
                return moment(value).format('Do MMM YYYY [at] HH:mm');
            }
        },
        computed: {
            therapistSkills() {
                return this.enquiry.therapist.skills
                    .map(function(skill) {
                        return skill.name;
                    })
                    .join(', ');
            }
        },
        methods: {
            fetchEnquiry() {
                enquiriesService
                    .get(this.$route.params.id)
                    .then((response) => {
                        this.enquiry = response.data;
                    })
                    .catch((error) => {
                        // window.location.href = `/error/${error.response.status}`;
                    });
            },
            cancelEnquiry() {
                enquiriesService
                    .cancel(this.enquiry.id)
                    .then(() => {
                        window.location.reload();
                    })
                    .catch((error) => {
                        window.location.href = `/error/${error.response.status}`;
                    });
            },
            createBooking() {
                if (!this.agrees) {
                    return this.$toasted.error(
                        'You have to agree to the terms and the privacy policy in order to continue.',
                        {
                            icon: 'exclamation-triangle'
                        }
                    );
                }

                enquiriesService
                    .createBooking(this.enquiry)
                    .then((response) => {
                        if (response.data.completed) {
                            this.enquiry.status = 'request_booking';
                            this.$toasted.success(response.data.message);
                        } else {
                            this.$router.push(`/enquiries/${this.enquiry.id}/edit`);
                        }
                    })
                    .catch((error) => {
                        if (error.response.status == 422) {
                            this.$toasted.error(error.response.data, {
                                icon: 'exclamation-triangle'
                            });

                            this.warnings.selectSession = true;
                            window.location.href = '#session-dates';
                        } else {
                            window.location.href = `/error/${error.response.status}`;
                        }
                    });
            },
            statusText() {
                return statusTextFilter[this.enquiry.status] || 'Unknown';
            },
            statusColor() {
                return statusColorFilter[this.enquiry.status] || 'card-header-unknown';
            },
            statusDescription() {
                return (
                    statusDescriptionFilter[this.enquiry.status] ||
                    'We could not retrieve any information about this enquiry. Try again later.'
                );
            },
            hasStatus(statuses) {
                for (status of statuses) {
                    if (this.enquiry.status == status) {
                        return true;
                    }
                }
                return false;
            }
        },
        mounted() {
            this.fetchEnquiry();
        }
    });

    /** Filters */
    const statusTextFilter = {
        pending: 'Pending',
        assigned_to_therapist: 'Pending',
        rejected_by_client: 'Cancelled',
        accepted: 'Waiting for your booking request',
        request_booking: 'Booking request sent',
        booking_accepted: 'Booking accepted'
    };

    const statusColorFilter = {
        pending: 'card-header-strong-pending',
        assigned_to_therapist: 'card-header-strong-pending',
        rejected_by_client: 'card-header-strong-rejected',
        accepted: 'card-header-strong-requested',
        request_booking: 'card-header-strong-request',
        booking_accepted: 'card-header-strong-accepted'
    };

    const statusDescriptionFilter = {
        pending: 'Your enquiry was successfully submitted and we have been notified.',
        assigned_to_therapist: 'Your enquiry was successfully submitted and we have been notified.',
        rejected_by_client: 'You cancelled this enquiry.',
        accepted: 'Our therapist accepted your enquiry. Please confirm session details and make a booking.',
        request_booking: 'Your booking request was sent to our therapist.',
        booking_accepted:
            'Your booking was accepted by our therapist. A confirmation email was sent to your email address.'
    };
</script>
